import React, { useEffect, useState } from 'react'
import './styles/multiplayer-home-page.css'
import '../../styles/fancy-text.css'
import FancyText from '../FancyText'
import { useNavigate } from "react-router-dom";
const { io } = require("socket.io-client")

export default function MultiplayerHomePage() {
    const socket = io('https://www.asuguesser.com')
    const [joinCode, setJoinCode] = useState("");
    let navigate = useNavigate();

    useEffect(() => {
        setTimeout(()=>{
            document.getElementById('multiplayer-new-game-join-game-wrapper').style.transform = 'translateX(0)'
        }, 10)
    }, []);

    // Generate 4-letter code
    function generateGameCode() {
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        let code = "";
        for (let i = 0; i < 4; i++) code += chars[Math.floor(Math.random() * chars.length)];
        return code;
    }

    // CREATE NEW GAME
    function createNewGame() {
        const gameCode = generateGameCode();
        
        socket.emit("createNewMultiplayerLobby", { gameSessionId: gameCode }, (response) => {
            if (response.status === 200) {
                navigate(`/multiplayer/${gameCode}`);
            } else {
                alert("Error creating lobby: " + response.message);
            }
        });
    }

    // JOIN EXISTING GAME
    function joinGame() {
        socket.emit("joinMultiplayerLobby", { gameSessionId: joinCode.toUpperCase() }, (response) => {
            if (response.status === 200) {
                navigate(`/multiplayer/${joinCode.toUpperCase()}`);
            } else {
                alert("Error joining lobby: " + response.message);
            }
        });
    }

    return (
        <div id='multiplayer-new-game-join-game-wrapper' className='multiplayer-new-game-join-game-wrapper'>

            <div id='multiplayer-new-game-wrapper' className='multiplayer-new-game-wrapper'>
                <div className='multiplayer-new-game-button' onClick={createNewGame}>
                    <FancyText InnerTextID={'new-game'} />
                </div>
            </div>

            <div id='multiplayer-join-game-wrapper' className='multiplayer-join-game-wrapper'>
                <input 
                    id='multiplayer-join-game-code-input'
                    className='multiplayer-join-game-code-input'
                    type='text'
                    placeholder='Enter 4 letter code'
                    maxLength='4'
                    onChange={(e) => setJoinCode(e.target.value)}
                    style={{ textTransform: "uppercase" }}
                    autoComplete='off'
                />

                <div 
                    id='multiplayer-join-game-button'
                    className='multiplayer-join-game-button'
                    onClick={joinGame}
                    style={{ opacity: joinCode.length === 4 ? 1 : 0.5, pointerEvents: joinCode.length === 4 ? "all" : "none" }}
                >
                    <FancyText InnerTextID={'join-game'} />
                </div>
            </div>

        </div>
    );
}
